import React from 'react';
import { volumes } from '../data/content';
export function Volumes() {
  return <section className="w-full bg-sand py-16 sm:py-20" aria-labelledby="volumes-heading" data-id="element-260" data-mp="1lv0auyvyebs6">
      <div className="mx-auto max-w-6xl px-5" data-id="element-261" data-mp="183vjsl6nirtg">
        <p className="font-sans text-xs font-bold uppercase tracking-[0.24em] text-gold" data-id="element-262" data-mp="1856kgc4svjgc">
          The complete system: 6 volumes
        </p>
        <h2 id="volumes-heading" className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight text-espresso sm:text-4xl" data-id="element-263" data-mp="1c3499duns3j7">
          Six volumes
        </h2>

        <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-264" data-mp="1qud72a8psv7f">
          {volumes.map(volume => <article key={volume.number} className="flex h-full flex-col rounded-2xl border border-espresso/10 bg-cream p-7" data-id="element-265" data-mp="1vt7s7iu5mvup">
              <p className="font-sans text-[11px] font-bold uppercase tracking-[0.18em] text-gold" data-id="element-266" data-mp="fhaoj9n21vkm">
                Vol. {volume.number}
              </p>
              <h3 className="mt-3 font-display text-2xl font-semibold leading-snug text-espresso" data-id="element-267" data-mp="3o97xgglfyeqb">
                {volume.title}
              </h3>
              <p className="mt-3 flex-1 font-sans text-base leading-relaxed text-cocoa" data-id="element-268" data-mp="3jbg9tyrtxerx">
                {volume.description}
              </p>
              <p className="mt-6 border-t border-espresso/10 pt-4 font-sans text-xs font-medium text-muted" data-id="element-269" data-mp="3t6zyq17z7d76">
                {volume.tags.join(' · ')}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}